import * as React from "react";
import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { Lightbox } from "react-modal-image";

import { cn } from "../../lib/utils";
import { getPublicFileUrl } from "../../config";

const Avatar = React.forwardRef(({ className, ...props }, ref) => (
  <AvatarPrimitive.Root
    ref={ref}
    className={cn("relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full", className)}
    {...props}
  />
));
Avatar.displayName = AvatarPrimitive.Root.displayName;

const AvatarImage = React.forwardRef(({ className, ...props }, ref) => (
  <AvatarPrimitive.Image
    ref={ref}
    className={cn("aspect-square h-full w-full object-cover", className)}
    {...props}
  />
));
AvatarImage.displayName = AvatarPrimitive.Image.displayName;

const AvatarFallback = React.forwardRef(({ className, ...props }, ref) => (
  <AvatarPrimitive.Fallback
    ref={ref}
    className={cn(
      "flex h-full w-full items-center justify-center rounded-full bg-muted text-muted-foreground",
      className
    )}
    {...props}
  />
));
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;

const AvatarPreview = ({
  previewUrl,
  alt = "",
  className = "",
  children,
  ...props
}) => {
  const [aberta, setAberta] = React.useState(false);

  const previewNormalizada = previewUrl ? getPublicFileUrl(previewUrl) : previewUrl;
  const temFoto = Boolean(previewNormalizada);

  const aoClicar = (e) => {
    e.stopPropagation();
    if (temFoto) setAberta(true);
  };

  return (
    <>
      <Avatar
        onClick={aoClicar}
        className={cn(temFoto && "cursor-pointer", className)}
        {...props}
      >
        {children}
      </Avatar>
      {aberta && temFoto && (
        <Lightbox
          medium={previewNormalizada}
          large={previewNormalizada}
          alt={alt}
          onClose={() => setAberta(false)}
          imageBackgroundColor="transparent"
        />
      )}
    </>
  );
};
AvatarPreview.displayName = "AvatarPreview";

export { Avatar, AvatarImage, AvatarFallback, AvatarPreview };
